import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-sitekey"]

import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  emits: ['verify'],
  setup(__props, { expose, emit }) {

onMounted(() => {
  render()
})

const MAX_RETRY = 20
let retryCount = 0

const siteKey = process?.env?.VUE_APP_SITE_KEY
const widgetId = ref()
const interval_recaptcha = ref()

const execute = () => {
  window.grecaptcha.enterprise.execute(widgetId.value)
}

const reset = () => {
  window.grecaptcha.enterprise.reset(widgetId.value)
}

expose({ reset, execute })

const renderRecaptcha = () => {
  // 2022/11/15 TienNV Fix bug Disabled button Login UAT#4529: OE56(Ph2-R20221116)
  let element = document.getElementById('g-recaptcha')
  if (typeof element != 'undefined' && element != null) {
    widgetId.value = window.grecaptcha.enterprise.render('g-recaptcha', {
      siteKey: siteKey,
      size: 'normal',
      hl: 'ja',
      // the callback executed when the user solve the recaptcha
      callback: (response) => {
        // emit an event called verify with the response as payload
        emit('verify', response)
      },
    })
  }
}

const render = () => {
  if (window.grecaptcha?.enterprise?.render) {
    renderRecaptcha()
  } else if (retryCount < MAX_RETRY) {
    retryCount++
    setTimeout(render, 200)
  } else {
    console.error('reCAPTCHA failed to load after retries.')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "g-recaptcha",
    "data-sitekey": _unref(siteKey)
  }, null, 8, _hoisted_1))
}
}

})